import BillingsOrderForwardBillingsDownloadResponse from "../../../../api/raily/billings/order-forward-billings/download/billings-order-forward-billings-download.response";
import BillingsOrderForwardBillingsDownload from "./billings-order-forward-billings-download";

const create = (
  response: BillingsOrderForwardBillingsDownloadResponse,
): BillingsOrderForwardBillingsDownload => {
  const data = response.data;

  return {
    data: data.data,
    filename: data.filename,
  };
};

const billingsOrderForwardBillingsDownloadFactory = {
  create,
};

export default billingsOrderForwardBillingsDownloadFactory;
